
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import {fetchList, getCancelReasonList} from '@/api/oms/order';
import { wait } from '@/utils/wait';

export default extend(table, {
    namespaced: true,
    state: {
        searchForm: {},
		reasonList: [],
		returnReasonList: []
    },
    actions: {
        async getList({ state, dispatch }, payload) {
            await wait(dispatch, 'oms.order.list', async function () {
                let { searchForm } = state;
                let params = {
                    orderStatus: searchForm.orderStatus,
                    verifyStatus: searchForm.verifyStatus,
                    paymentMethod: searchForm.paymentMethod,
                    terminalType: searchForm.terminalType,
                    confirmType: searchForm.confirmType,
                }
                if(searchForm.select && searchForm.value){
					params[searchForm.select] = searchForm.value
				}
                if (searchForm.timeSelect && searchForm.timeValue) {
                    params[searchForm.timeSelect] = {
                        start: parseInt(searchForm.timeValue[0] / 1000),
                        end: parseInt(searchForm.timeValue[1] / 1000)
                    }
                }
                if (searchForm.amountStart && searchForm.amountEnd) {
                    params.totalAmount = {
                        start: searchForm.amountStart,
                        end: searchForm.amountEnd
                    }
                }
                await dispatch('getData', {
                    caller: fetchList,
                    options: {
                        ...params,
                        ...payload
                    }
                });
            })
        },
		async getReasonList({ state, dispatch, commit }, payload) {
			await wait(dispatch, 'oms.order.list', async function () {
				await wait(dispatch, 'sms.order.reason-list', async function() {
					const response = await getCancelReasonList();
					if (response.data) {
						commit('save', {
							reasonList: response.data
						})
					}
				})
			})
		}
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/order/list.js